<template>
  <component
    :is="iconComponent"
    :viewBox="viewBox"
    :width="size"
    :height="size"
    :fill="fill"
    :stroke="stroke"
  />
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    size: {
      type: [String, Number],
      default: '18px',
    },
    fill: {
      type: String,
      default: 'none',
    },
    stroke: {
      type: String,
      default: '#979BA7',
    },
  },
  computed: {
    iconComponent() {
      return () => import(`@/assets/icons/${this.name}.svg`);
    },
  },
};
</script>
